import { defineStore } from 'pinia'
import { KycIntegrationInfoDTO } from '@/models/kyc-integration-info-dto'
import KycService from '@/services/kyc.service'

export const useKycStore = defineStore('kyc', {
  state: () => ({
    kycInfo: null as KycIntegrationInfoDTO | null,
    loading: false,
    error: null as string | null
  }),
  actions: {
    async fetchKycInfo(clientId: number, autoInitiate = false) {
      this.loading = true
      try {
        this.kycInfo = await KycService.getClientKycIntegrationInfo(clientId, autoInitiate)
        this.error = null
      } catch (e: any) {
        this.error = e?.message || 'Erreur lors de la récupération KYC'
      } finally {
        this.loading = false
      }
    },
    clearKycInfo() {
      this.kycInfo = null
      this.error = null
    }
  }
})
